// Cross-pipeline ORT run-serialization gate.
//
// The JSEP WebGPU EP processes one inference at a time PER RUNTIME: two
// overlapping `session.run()` calls — even on different InferenceSession
// objects, even across different pipelines (the Isaac face in
// src/ogs/ + the hair runner in src/hair/) that share the one
// `onnxruntime-web` (JSEP) runtime — throw "Session already started" /
// "Session mismatch" (and a heap OOB on WASM). Every consumer of the shared
// runtime MUST route its session create + run through this single module-level
// gate so no two ORT ops ever overlap.
//
// Cost is one microtask hop per op. Runs `fn` whether the prior op resolved or
// rejected, so one failure can't wedge the queue.
let ortGate = Promise.resolve();

/**
 * Run `fn` once every earlier gated op has settled, and return WHAT IT RETURNS —
 * the annotation matters because this module is untyped JS: without it every
 * caller inferred `Promise<void>` and cast the result back, which is four of the
 * repo's type-debt sites and one real trap (a caller that forgets the cast gets
 * `void`, not an error).
 *
 * @template T
 * @param {() => T | Promise<T>} fn
 * @returns {Promise<T>}
 */
export function withOrtGate(fn) {
  const run = ortGate.then(fn, fn);
  ortGate = run.then(() => undefined, () => undefined);
  return run;
}
